import { ProductEndpoints } from '@/modules/inventory/product/api/productEndpoints'

/**
 * Product endpoint instance
 * instantiate product api class with a different api path
 */
export const productEndpoints = new ProductEndpoints('product')
